import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1005"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4.419 5.109c.971 0 2.115-.167 3.418-.631 4.59-1.634 6.684-.039 6.766.025a.699.699 0 1 0 .892-1.078c-.109-.091-2.728-2.186-8.127-.266-3.798 1.352-5.857-.191-5.946-.26a.7.7 0 0 0-.87 1.096c.078.063 1.431 1.114 3.867 1.114zm2.95 2.197c-3.798 1.351-5.857-.19-5.946-.26a.7.7 0 0 0-.871 1.096c.078.063 1.431 1.114 3.867 1.114.971 0 2.115-.167 3.418-.631 4.59-1.634 6.684-.039 6.766.025a.699.699 0 1 0 .892-1.078c-.108-.09-2.726-2.185-8.126-.266zm-.879 4.136c-3.223 1.106-4.975-.246-5.057-.312a.7.7 0 0 0-.892 1.079c.07.059 1.313 1.065 3.544 1.065.822 0 1.778-.137 2.858-.508a.7.7 0 0 0-.453-1.324zm8.035-.073h-1.26l.63-1.091a.702.702 0 0 0-.256-.957.704.704 0 0 0-.957.256l-.63 1.091-.63-1.091a.702.702 0 0 0-1.213.701l.63 1.091H9.58a.7.7 0 1 0 0 1.4h1.26l-.63 1.091a.702.702 0 0 0 .606 1.051.7.7 0 0 0 .607-.35l.63-1.091.63 1.091a.7.7 0 0 0 .957.256.702.702 0 0 0 .256-.957l-.63-1.091h1.26a.7.7 0 1 0-.001-1.4z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }